import { Typography } from 'antd'
import React, { FunctionComponent, memo } from 'react'

import { AuctionDetailDrawerQuery } from '../../../graphql/generated'
import { TableCellLabels } from '../TableCellLabels/TableCellLabels'

export interface AuctionDetailDrawerTitleProps {
  detailUrl: string
  title: string
  auction: AuctionDetailDrawerQuery['auctionListingById']
}

const { Title } = Typography
const titleStyle = { marginBottom: 0 }

export const AuctionDetailDrawerTitle: FunctionComponent<AuctionDetailDrawerTitleProps> =
  memo(props => {
    return (
      <div className="flex flex-col">
        <a
          href={props.detailUrl}
          target="_blank"
          rel="noreferrer"
          title="Přejít na dražbu v novém okně"
        >
          <Title
            level={4}
            style={titleStyle}
            className="hover:!text-primaryHover transition-colors first-letter:uppercase"
          >
            Dražba: {props.title}
          </Title>
        </a>
        <TableCellLabels
          labels={props.auction?.labels}
          labelEntityType="auctionListingId"
          recordId={props.auction?.id || ''}
          modalTitle={props.auction?.title}
          alignment="labelFirst"
          buttonText={
            props.auction?.labels?.nodes?.length
              ? 'Upravit štítky'
              : 'Přidat štítky'
          }
        />
      </div>
    )
  })
